// src/app/components/ExpLayout/ExpLayout.jsx
import useSettings from "app/hooks/useSettings";
import ExpSuspense from "../ExpSuspense";
import { ExpLayouts } from "./index";

export default function ExpLayout(props) {
  const { settings } = useSettings();
  const Layout = ExpLayouts[settings.activeLayout];

  return (
    <ExpSuspense>
      <Layout {...props} />
    </ExpSuspense>
  );
}
